import axiosInstance from '../config/axios';

// Service mẫu cho API calls
export const userService = {
	// Lấy danh sách users (admin)
	getAll: (params) => {
		return axiosInstance.get('/users', { params });
	},

	// Lấy thông tin user theo ID
	getById: (id) => {
		return axiosInstance.get(`/users/${ id }`);
	},

	// Tạo user mới
	create: (data) => {
		return axiosInstance.post('/users', data);
	},

	// Cập nhật user
	update: (id, data) => {
		return axiosInstance.put(`/users/${ id }`, data);
	},

	// Toggle khoá / mở khoá user
	toggleStatus: (id) => {
		return axiosInstance.patch(`/users/${ id }/toggle-status`);
	},

	// Xóa user
	delete: (id) => {
		return axiosInstance.delete(`/users/${ id }`);
	},

	// Upload avatar
	uploadAvatar: (id, file) => {
		const formData = new FormData();
		formData.append('avatar', file);
		return axiosInstance.post(`/users/${ id }/avatar`, formData);
	},

	// Lấy thu nhập của chính mình (lương cứng + hoa hồng từ booking)
	getMyIncome: (params) => {
		return axiosInstance.get('/users/me/income', { params });
	},

	// Admin lấy thu nhập của 1 user
	getIncome: (id, params) => {
		return axiosInstance.get(`/users/${ id }/income`, { params });
	},

	// Lấy danh sách admin đang hoạt động (online) — cho phần chat của user
	getActiveAdmins: () => {
		return axiosInstance.get('/users/admins/active');
	},
};

// Service cho authentication
export const authService = {
	// Đăng nhập
	login: (credentials) => {
		return axiosInstance.post('/auth/login', credentials);
	},

	// Đăng ký
	register: (userData) => {
		return axiosInstance.post('/auth/register', userData);
	},

	// Đăng xuất
	logout: () => {
		return axiosInstance.post('/auth/logout');
	},

	// Revoke token
	revokeToken: () => {
		return axiosInstance.post('/auth/revoke-token');
	},

	// Lấy thông tin user hiện tại
	getCurrentUser: () => {
		return axiosInstance.get('/auth/me');
	},

	// Who am I - Kiểm tra quyền truy cập
	whoAmI: () => {
		return axiosInstance.get('/auth/who-am-i');
	},

	// Refresh token
	refreshToken: (refreshToken) => {
		return axiosInstance.post('/auth/refresh-token', { refreshToken });
	},

	// Quên mật khẩu
	forgotPassword: (email) => {
		return axiosInstance.post('/auth/forgot-password', { email });
	}
};

// Service cho hotels
export const hotelService = {
	getAll: (params) => axiosInstance.get('/hotels', { params }),

	getById: (id) => axiosInstance.get(`/hotels/${ id }`),

	create: (data) => axiosInstance.post('/hotels', data),

	update: (id, data) => axiosInstance.put(`/hotels/${ id }`, data),

	delete: (id) => axiosInstance.delete(`/hotels/${ id }`),

	uploadImages: (id, files) => {
		const formData = new FormData();
		files.forEach((f) => formData.append('images', f));
		return axiosInstance.post(`/hotels/${ id }/images`, formData);
	},

	deleteImage: (id, imageId) => axiosInstance.delete(`/hotels/${ id }/images/${ imageId }`),

	setCoverImage: (id, imageId) => axiosInstance.patch(`/hotels/${ id }/cover/${ imageId }`),

	uploadHighlightImage: (id, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/hotels/${ id }/highlight-image`, formData);
	},

	uploadFacilityImage: (id, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/hotels/${ id }/facility-image`, formData);
	},
};

// Service cho rooms
export const roomService = {
	getAll: (params) => {
		return axiosInstance.get('/rooms', { params });
	},

	getById: (id) => {
		return axiosInstance.get(`/rooms/${ id }`);
	},

	create: (data) => {
		return axiosInstance.post('/rooms', data);
	},

	update: (id, data) => {
		return axiosInstance.put(`/rooms/${ id }`, data);
	},

	delete: (id) => {
		return axiosInstance.delete(`/rooms/${ id }`);
	},

	checkAvailability: (id, data) => {
		return axiosInstance.post(`/rooms/${ id }/check-availability`, data);
	},

	uploadImages: (id, files) => {
		const form = new FormData();
		files.forEach((f) => form.append('images', f));
		return axiosInstance.post(`/rooms/${ id }/images`, form);
	},

	deleteImage: (id, index) => {
		return axiosInstance.delete(`/rooms/${ id }/images/${ index }`);
	},

	setCoverImage: (id, index) => {
		return axiosInstance.put(`/rooms/${ id }/images/${ index }/cover`);
	},
};

// Service cho bookings
export const bookingService = {
	getAll: (params) => {
		return axiosInstance.get('/bookings', { params });
	},

	getById: (id) => {
		return axiosInstance.get(`/bookings/${ id }`);
	},

	create: (data) => {
		return axiosInstance.post('/bookings', data);
	},

	updateStatus: (id, data) => {
		return axiosInstance.put(`/bookings/${ id }/status`, data);
	},

	cancel: (id, reason) => {
		return axiosInstance.put(`/bookings/${ id }/cancel`, { reason });
	}
};

// Service cho reviews
export const reviewService = {
	getAll: (params) => {
		return axiosInstance.get('/reviews', { params });
	},

	getById: (id) => {
		return axiosInstance.get(`/reviews/${ id }`);
	},

	create: (data) => {
		return axiosInstance.post('/reviews', data);
	},

	updateStatus: (id, status) => {
		return axiosInstance.put(`/reviews/${ id }/status`, { status });
	},

	reply: (id, admin_reply) => {
		return axiosInstance.put(`/reviews/${ id }/reply`, { admin_reply });
	},

	delete: (id) => {
		return axiosInstance.delete(`/reviews/${ id }`);
	},

	getMyReviews: (params) => {
		return axiosInstance.get('/reviews/my-reviews', { params });
	},

	getStats: (params) => {
		return axiosInstance.get('/reviews/stats', { params });
	}
};

// Service cho vouchers
export const voucherService = {
	getAll: (params) => axiosInstance.get('/vouchers', { params }),
	getById: (id) => axiosInstance.get(`/vouchers/${ id }`),
	create: (data) => axiosInstance.post('/vouchers', data),
	update: (id, data) => axiosInstance.put(`/vouchers/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/vouchers/${ id }`),
	validate: (data) => axiosInstance.post('/vouchers/validate', data),
};

// Service cho admin
export const adminService = {
	getDashboardStats: () => {
		return axiosInstance.get('/bookings/admin/dashboard/stats');
	}
};

// Service cho site settings
export const settingsService = {
	getSettings: () => axiosInstance.get('/settings'),

	uploadLogo: (file) => {
		const formData = new FormData();
		formData.append('logo', file);
		return axiosInstance.post('/settings/logo', formData);
	},

	deleteLogo: () => axiosInstance.delete('/settings/logo'),

	addMenuItem: (data) => axiosInstance.post('/settings/menu', data),

	updateMenuItem: (itemId, data) => axiosInstance.put(`/settings/menu/${ itemId }`, data),

	deleteMenuItem: (itemId) => axiosInstance.delete(`/settings/menu/${ itemId }`),

	uploadMenuIcon: (itemId, file) => {
		const formData = new FormData();
		formData.append('icon', file);
		return axiosInstance.post(`/settings/menu/${ itemId }/icon`, formData);
	},

	updateBookingAlert: (data) => axiosInstance.put('/settings/booking-alert', data),

	uploadBookingAlertImage: (file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post('/settings/booking-alert/image', formData);
	},

	deleteBookingAlertImage: () => axiosInstance.delete('/settings/booking-alert/image'),

	addUserAlert: (data) => axiosInstance.post('/settings/user-alert', data),
	updateUserAlert: (id, data) => axiosInstance.put(`/settings/user-alert/${ id }`, data),
	uploadUserAlertImage: (id, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/settings/user-alert/${ id }/image`, formData);
	},
	deleteUserAlert: (id) => axiosInstance.delete(`/settings/user-alert/${ id }`),

	uploadUserBackground: (file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post('/settings/user-background', formData);
	},
	deleteUserBackground: () => axiosInstance.delete('/settings/user-background'),

	updateAboutContent: (aboutContent) => axiosInstance.put('/settings/about', { aboutContent }),
	uploadAboutImage: (file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post('/settings/about/image', formData);
	},
};

// Service cho chat/conversations
export const chatService = {
	getConversations: (params) => {
		return axiosInstance.get('/conversations', { params });
	},

	getOrCreateDirect: (otherUserId) => {
		return axiosInstance.post('/conversations/direct', { otherUserId });
	},

	getMessages: (conversationId, params) => {
		return axiosInstance.get(`/conversations/${ conversationId }/messages`, { params });
	},

	sendMessage: (conversationId, data) => {
		return axiosInstance.post(`/conversations/${ conversationId }/messages`, data);
	},

	markAsRead: (conversationId) => {
		return axiosInstance.put(`/conversations/${ conversationId }/read`);
	},

	updateTheme: (conversationId, { theme, themeName, bubbleColor, bgImageFile } = {}) => {
		if (bgImageFile) {
			const fd = new FormData();
			fd.append('bgImage', bgImageFile);
			if (themeName) fd.append('themeName', themeName);
			if (bubbleColor !== undefined) fd.append('bubbleColor', bubbleColor || '');
			return axiosInstance.put(`/conversations/${ conversationId }/theme`, fd);
		}
		return axiosInstance.put(`/conversations/${ conversationId }/theme`, { theme: theme ?? undefined, themeName, bubbleColor });
	},
	recallMessage: (conversationId, messageId) => axiosInstance.patch(`/conversations/${ conversationId }/messages/${ messageId }/recall`),
	deleteConversation: (conversationId) => axiosInstance.delete(`/conversations/${ conversationId }`)
};

// Service cho notifications
export const notificationService = {
	getAll: (params) => {
		return axiosInstance.get('/notifications', { params });
	},

	markAsRead: (id) => {
		return axiosInstance.put(`/notifications/${ id }/read`);
	},

	markAllAsRead: () => {
		return axiosInstance.put('/notifications/read-all');
	},

	delete: (id) => {
		return axiosInstance.delete(`/notifications/${ id }`);
	}
};

// Service cho favorites (khách sạn yêu thích)
export const favoriteService = {
	getAll: () => {
		return axiosInstance.get('/users/me/favorites');
	},
	add: (hotelId) => {
		return axiosInstance.post(`/users/me/favorites/${ hotelId }`);
	},
	remove: (hotelId) => {
		return axiosInstance.delete(`/users/me/favorites/${ hotelId }`);
	}
};

// Service cho nationalities
export const nationalityService = {
	getAll: (params) => {
		return axiosInstance.get('/nationalities', { params });
	},

	getById: (id) => {
		return axiosInstance.get(`/nationalities/${ id }`);
	},

	create: (data) => {
		return axiosInstance.post('/nationalities', data);
	},

	update: (id, data) => {
		return axiosInstance.put(`/nationalities/${ id }`, data);
	},

	delete: (id) => {
		return axiosInstance.delete(`/nationalities/${ id }`);
	},
};

// Service cho amenities (master data tiện nghi)
export const amenityService = {
	getAll: (params) => axiosInstance.get('/amenities', { params }),
	getById: (id) => axiosInstance.get(`/amenities/${ id }`),
	create: (data) => axiosInstance.post('/amenities', data),
	update: (id, data) => axiosInstance.put(`/amenities/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/amenities/${ id }`),
	uploadIcon: (id, file) => {
		const formData = new FormData();
		formData.append('icon', file);
		return axiosInstance.post(`/amenities/${ id }/icon`, formData);
	},
};

// Service cho bed types (loại giường)
export const bedTypeService = {
	getAll: (params) => axiosInstance.get('/bed-types', { params }),
	create: (data) => axiosInstance.post('/bed-types', data),
	update: (id, data) => axiosInstance.put(`/bed-types/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/bed-types/${ id }`),
	uploadImage: (id, file) => {
		const fd = new FormData();
		fd.append('image', file);
		return axiosInstance.post(`/bed-types/${ id }/image`, fd);
	},
};

// Service cho extra types (loại dịch vụ)
export const extraTypeService = {
	getAll: (params) => axiosInstance.get('/extra-types', { params }),
	create: (data) => axiosInstance.post('/extra-types', data),
	update: (id, data) => axiosInstance.put(`/extra-types/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/extra-types/${ id }`),
	uploadIcon: (id, file) => {
		const fd = new FormData();
		fd.append('icon', file);
		return axiosInstance.post(`/extra-types/${ id }/icon`, fd);
	},
};

// Service cho categories
export const categoryService = {
	getAll: (params) => axiosInstance.get('/categories', { params }),
	getById: (id) => axiosInstance.get(`/categories/${ id }`),
	create: (data) => axiosInstance.post('/categories', data),
	update: (id, data) => axiosInstance.put(`/categories/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/categories/${ id }`),
	uploadIcon: (id, file) => {
		const formData = new FormData();
		formData.append('icon', file);
		return axiosInstance.post(`/categories/${ id }/icon`, formData);
	},
};

// Service cho provinces / wards
export const provinceService = {
	getAll: (params) => axiosInstance.get('/provinces', { params }),
	getTopByHotelCount: (limit = 10) => axiosInstance.get('/provinces/top-hotels', { params: { limit } }),
	getByCode: (code) => axiosInstance.get(`/provinces/${ code }`),
	getWards: (code) => axiosInstance.get(`/provinces/${ code }/wards`),
	uploadProvinceImage: (code, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/provinces/${ code }/image`, formData);
	},
	uploadWardImage: (code, wardCode, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/provinces/${ code }/wards/${ wardCode }/image`, formData);
	},
};

// Service cho posts (bài viết)
export const postService = {
	getAll: (params) => axiosInstance.get('/posts', { params }),
	getById: (id) => axiosInstance.get(`/posts/${ id }`),
	create: (data) => axiosInstance.post('/posts', data),
	update: (id, data) => axiosInstance.put(`/posts/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/posts/${ id }`),
	uploadCover: (id, file) => {
		const formData = new FormData();
		formData.append('cover', file);
		return axiosInstance.post(`/posts/${ id }/cover`, formData);
	},
};

// Service quản lý LƯƠNG CỨNG theo tháng
export const salaryService = {
	listByUser: (userId, params) => axiosInstance.get(`/salaries/user/${ userId }`, { params }),
	getMonth: (userId, params) => axiosInstance.get(`/salaries/user/${ userId }/month`, { params }),
	upsert: (data) => axiosInstance.post('/salaries', data),
	delete: (id) => axiosInstance.delete(`/salaries/${ id }`),
};

// Service quản lý TẠM ỨNG (advance payment)
export const advanceService = {
	listByUser: (userId, params) => axiosInstance.get(`/advances/user/${ userId }`, { params }),
	create: (data) => axiosInstance.post('/advances', data),
	update: (id, data) => axiosInstance.put(`/advances/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/advances/${ id }`),
};

// Service quản lý PHIẾU LƯƠNG (payroll)
export const payrollService = {
	// Admin
	listIncomes: (params) => axiosInstance.get('/payrolls/incomes', { params }),
	getUserIncome: (userId, params) => axiosInstance.get(`/payrolls/income/${ userId }`, { params }),
	issue: (data) => axiosInstance.post('/payrolls/issue', data),
	delete: (id) => axiosInstance.delete(`/payrolls/${ id }`),
	// User
	listMine: (params) => axiosInstance.get('/payrolls/me', { params }),
	getPending: () => axiosInstance.get('/payrolls/me/pending'),
	confirm: (id) => axiosInstance.put(`/payrolls/${ id }/confirm`),
	requestReview: (id, reason) => axiosInstance.put(`/payrolls/${ id }/review`, { reason }),
};

// Service YÊU CẦU PHÁT LƯƠNG (payroll request)
export const payrollRequestService = {
	// User
	create: (data) => axiosInstance.post('/payroll-requests', data || {}),
	listMine: () => axiosInstance.get('/payroll-requests/me'),
	cancel: (id) => axiosInstance.delete(`/payroll-requests/${ id }`),
	// Admin
	list: (params) => axiosInstance.get('/payroll-requests', { params }),
	pendingCount: () => axiosInstance.get('/payroll-requests/pending-count'),
	reject: (id, reason) => axiosInstance.put(`/payroll-requests/${ id }/reject`, { reason }),
};

// Service quản lý TOUR
export const tourService = {
	getAll: (params) => axiosInstance.get('/tours', { params }),
	getById: (id) => axiosInstance.get(`/tours/${ id }`),
	create: (data) => axiosInstance.post('/tours', data),
	update: (id, data) => axiosInstance.put(`/tours/${ id }`, data),
	delete: (id) => axiosInstance.delete(`/tours/${ id }`),
	uploadImage: (id, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/tours/${ id }/image`, formData);
	},
	uploadHighlightImage: (id, file) => {
		const formData = new FormData();
		formData.append('image', file);
		return axiosInstance.post(`/tours/${ id }/highlight-image`, formData);
	},
	uploadImages: (id, files) => {
		const formData = new FormData();
		files.forEach((f) => formData.append('images', f));
		return axiosInstance.post(`/tours/${ id }/images`, formData);
	},
	deleteImage: (id, imgPath) =>
		axiosInstance.delete(`/tours/${ id }/images`, { data: { path: imgPath } }),
};

// Service quản lý ĐƠN BỐC NGẪU NHIÊN (random booking)
export const randomBookingService = {
	list: (params) => axiosInstance.get('/random-bookings', { params }),
	myStatus: () => axiosInstance.get('/random-bookings/me'),
	spin: (data) => axiosInstance.post('/random-bookings/spin', data || {}),
	getById: (id) => axiosInstance.get(`/random-bookings/${ id }`),
	requestCancel: (id, reason) => axiosInstance.put(`/random-bookings/${ id }/cancel-request`, { reason }),
	decideCancel: (id, action, adminNote) => axiosInstance.put(`/random-bookings/${ id }/decide`, { action, adminNote }),
	update: (id, data) => axiosInstance.put(`/random-bookings/${ id }`, data),
	remove: (id) => axiosInstance.delete(`/random-bookings/${ id }`),
	markDiscounted: (ids) => axiosInstance.put('/random-bookings/mark-discounted', { ids }),
};

// Export tất cả services dưới dạng object
export const apiService = {
	auth: authService,
	users: userService,
	hotels: hotelService,
	rooms: roomService,
	bookings: bookingService,
	reviews: reviewService,
	admin: adminService,
	salaries: salaryService,
	advances: advanceService,
	payrolls: payrollService,
	payrollRequests: payrollRequestService,
	tours: tourService,
	randomBookings: randomBookingService,
};
